// QualiApps site v2 — /aulas page boot (waitlist).
// Entry mais leve que main.ts: sem hero parallax, familia, estimator, portfolio.

import './styles/tokens.css';
import './styles/base.css';
import './styles/typography.css';
import './styles/layout.css';
import './styles/aulas-page.css';

import { initTheme } from './lib/theme';
import { initI18n } from './lib/i18n';
import { bindI18nAutoApply } from './lib/i18n-dom';
import { initHeader } from './modules/header';
import { initMobileMenu } from './modules/mobile-menu';
import { initThemeToggle } from './modules/theme-toggle';
import { initLanguageToggle } from './modules/language-toggle';
import { initPrivacyModal } from './modules/privacy-modal';
import { initReveal } from './modules/reveal';
import { initWaitlistForm } from './modules/waitlist-form';

initTheme();
initHeader();
initMobileMenu();
initPrivacyModal();
initReveal();

void initI18n().then(() => {
  bindI18nAutoApply();
  initThemeToggle();
  initLanguageToggle();
  initWaitlistForm();
});

// Rewrite âncoras `#xxx` → `/#xxx` para que links do header/footer/mobile-menu
// (que apontam pra sections do one-pager) voltem pra landing e scrollem.
// Roda sync no carregamento; aciona uma vez é suficiente porque partials são
// inlined no build (DOM já está completo aqui).
(function rewriteAnchorsToHome(): void {
  const anchors = document.querySelectorAll<HTMLAnchorElement>('a[href^="#"]');
  for (const a of Array.from(anchors)) {
    const href = a.getAttribute('href');
    if (!href || href === '#') continue;
    a.setAttribute('href', `/${href}`);
  }
})();

// Year stamp no footer
const yearEl = document.getElementById('year');
if (yearEl) yearEl.textContent = String(new Date().getFullYear());

export {};
